import React, { useState } from 'react';
import ManageContacts from './manage-contacts.component';

interface IManageContactsContainer {
  contacts: IPlayerContact[];
  addContact: Function;
  removeContact: Function;
  updateContact: Function;
}

export const ManageContactsContainer: React.FC<IManageContactsContainer> = ({
  contacts,
  addContact,
  removeContact,
  updateContact,
}) => {
  const [isCreating, setCreating] = useState(false);
  const [activeEditContact, setActiveEditContact] = useState();

  return <ManageContacts
    contacts={contacts}
    activeEditContact={activeEditContact}
    setActiveEditContact={setActiveEditContact}
    isCreating={isCreating}
    setCreating={setCreating}
    addContact={addContact}
    removeContact={removeContact}
    updateContact={updateContact}
  />;
};
